module.exports = __webpack_public_path__ + "static/media/KoyoSeiko.c8b96c13.png";